import { ANNOYED_MS, FUN_POKE_ACTIONS, type PokeCss } from '../habitat/pokeReactions';
import type { Gesture } from './types';

// Typed on PokeCss, so a new poke class without a 3D gesture fails tsc.
const NAMES: Record<PokeCss, Gesture> = {
  'habitat-poke': 'poke', 'habitat-poke-wiggle': 'wiggle', 'habitat-poke-spin': 'spin', 'habitat-poke-hop': 'hop',
  'habitat-poke-tip': 'tip', 'habitat-poke-zoom': 'zoom', 'habitat-poke-annoyed': 'annoyed',
};

/** A Habitat poke CSS class → the 3D gesture of the same name and length. */
export function gestureForPokeClass(cls: string | null): { gesture: Gesture; ms: number } | null {
  if (cls === 'habitat-poke-annoyed') return { gesture: 'annoyed', ms: ANNOYED_MS };
  const a = FUN_POKE_ACTIONS.find((x) => x.css === cls);
  return a ? { gesture: NAMES[a.css], ms: a.ms } : null;
}
